import type { ReactNode } from 'react';
import { HelpTip } from '@/components/HelpTip';
import * as Styled from './Amounts.styled';

interface LineItemProps {
  extraData?: string;
  flipIcon?: boolean;
  icon?: ReactNode;
  isTotal?: boolean;
  label: string;
  tooltip?: string;
  value: string;
}

export const LineItem = ({
  extraData,
  flipIcon = false,
  icon,
  isTotal = false,
  label,
  tooltip,
  value,
}: LineItemProps) => (
  <Styled.Line $isTotal={isTotal}>
    <Styled.Key $flipIcon={flipIcon}>
      {label}
      {icon}
      {tooltip ? (
        <HelpTip label="Shipping information" tip={tooltip} variant="info" />
      ) : null}
      {extraData ? <Styled.Text>{extraData}</Styled.Text> : null}
    </Styled.Key>
    <Styled.Value $nonCurrency={!/€/.test(value)}>{value}</Styled.Value>
  </Styled.Line>
);
